import Component, { mixins } from 'vue-class-component'

import WithRender from './FicheRepondantBreadcrumbs.html'

import { 
  MIconButton,
  MIconButtonSkin,
  MLink,
  MLinkMode
} from '@ulaval/modul-components'

import ROUTES from '@/router/ROUTES';
import { ILocalizedRouteParameters, extractLocalizedRouteParameters } from '@/router/helpers';

export interface IBreadcrumbItem {
  label: string;
  href: string;
}

@WithRender
@Component({
  components: {
    MIconButton,
    MLink
  }
})
export default class FicheRepondantBreadcrumbs extends mixins() {
  private readonly MIconButtonSkin: object = MIconButtonSkin
  private readonly MLinkMode: object = MLinkMode

  private get items(): Array<IBreadcrumbItem> {
    if (!this.$route || !this.$route.matched) {
      return []
    }

    const breadcrumbs: Array<IBreadcrumbItem> = []

    const currentRouteNameParameters: ILocalizedRouteParameters = extractLocalizedRouteParameters(this.$route.name as string)

    if (
      currentRouteNameParameters.name === ROUTES.FICHE_REPONDANT_CREATE ||
      currentRouteNameParameters.name === ROUTES.FICHE_REPONDANT_UPDATE
    ) {
      breadcrumbs.push({
        label: '',
        href: this.mixin_router_generateHref({
          name: ROUTES.FICHE_REPONDANT_OVERVIEW,
          params: this.$route.params,
          query: this.$route.query
        })
      }) 
    }

    return breadcrumbs
  }
}
